import { Box, Button, SxProps, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CAppPaper from '../../../../app/components/CAppPaper';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import langUserProfile from '../../langs/langUserProfile';

type VUserProfilePersonalDataProps = {
	sxStyle: SxProps;
};

const VUserProfilePersonalData = (props: VUserProfilePersonalDataProps) => {
	const { sxStyle } = props;
	const theme = useTheme();
	const { t } = useTranslation();
	return (
		<CAppPaper
			sx={{ ...sxStyle, padding: '30px', backgroundColor: '#012144!important' }}
			variant="outlined"
			color="primary"
			displayBackgroundImage
			bgVariant="stars"
		>
			<Box
				sx={{
					color: '#FFF',
					textAlign: 'center',
					marginBottom: '20px',
					fontWeight: 600,
					fontSize: '1.375rem',
					lineHeight: '1.5',
				}}
			>
				{t(langUserProfile.text_we_protect_your_personal_data.tag)}
			</Box>
			<Box sx={{ textAlign: 'center' }}>
				<Button
					onClick={(e) => {
						window.location.href = 'mailto:dpo@sienna-im.com';
						e.preventDefault();
					}}
					variant="contained"
					color={theme.palette.mode === 'light' ? 'inherit' : 'secondary'}
					size="small"
					startIcon={<AppCustomIcon tag="user_protect" className="icon" />}
					sx={{
						color: theme.palette.primary.main,
						fontSize: '0.95rem',
						lineHeight: '1',
					}}
				>
					{t(langUserProfile.btn_contact_protection_officer.tag)}
				</Button>
			</Box>
		</CAppPaper>
	);
};

export default VUserProfilePersonalData;
